var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.textContent") } },
    [
      _c("el-input", {
        attrs: { type: "textarea", rows: 3 },
        model: {
          value: _vm.optionModel.textContent,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "textContent", $$v)
          },
          expression: "optionModel.textContent",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }